import { render } from "./PetRegister.vue?vue&type=template&id=70498ad7&scoped=true&ts=true"
import script from "./PetRegister.vue?vue&type=script&lang=ts"
export * from "./PetRegister.vue?vue&type=script&lang=ts"

import "./PetRegister.vue?vue&type=style&index=0&id=70498ad7&scoped=true&lang=css"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70498ad7"]])

export default __exports__